import * as React from "react";
const SvgFiRrReservationTable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23.938 17.305 21.966 6.131A4.99 4.99 0 0 0 17.042 2H6.958C3.5 2 2.294 4.655 2.034 6.131L.062 17.305a4 4 0 0 0 .875 3.267 4 4 0 0 0 3.064 1.429H5a1 1 0 1 0 0-2h-.999a2 2 0 0 1-1.532-.715 2 2 0 0 1-.438-1.633L4.003 6.479c.062-.354.185-.684.355-.979l2.339 12.426a5.004 5.004 0 0 0 4.914 4.075h8.387a3.99 3.99 0 0 0 3.064-1.429 4 4 0 0 0 .876-3.267m-2.407 1.98a2 2 0 0 1-1.532.715h-8.387a3 3 0 0 1-2.948-2.444L6.133 4.115q.396-.113.824-.114h10.085a2.995 2.995 0 0 1 2.954 2.479l1.972 11.174a2 2 0 0 1-.438 1.633zM10 9a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm.731 4a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm8.769 3a1 1 0 0 1-1 1h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1"
    />
  </svg>
);
export default SvgFiRrReservationTable;
